import { GameNavigator } from "../core/Navigation";
import { AdFarmSession } from "../integration/AdFarmSession";
import { MobileOverview } from "../integration/AdFarmTypes";
import { Theme } from "./Theme";
import { UIFactory } from "./UIFactory";

export class BackendBalanceChip extends Laya.Box {
    private readonly session = AdFarmSession.instance;
    private readonly valueLabel: Laya.Label;

    constructor(nav: GameNavigator) {
        super();
        this.width = 190;
        this.height = 62;
        this.mouseEnabled = true;
        UIFactory.roundRect(this, 0, 3, 190, 56, 28, "#392C27", "#E9B754", 3);
        this.graphics.drawCircle(31, 31, 23, "#F5B629", "#FFF0A2", 3);
        const icon = UIFactory.label("¥", 25, "#FFF4C2", 46, 46, true);
        icon.pos(8, 8);
        icon.stroke = 2;
        icon.strokeColor = "#B76A14";
        icon.mouseEnabled = false;
        this.addChild(icon);
        this.valueLabel = UIFactory.label("--", 25, "#FFF0A2", 128, 50, true);
        this.valueLabel.pos(55, 6);
        this.valueLabel.mouseEnabled = false;
        this.addChild(this.valueLabel);
        this.on(Laya.Event.CLICK, this, (event: Laya.Event) => {
            event.stopPropagation();
            Laya.timer.callLater(this, () => nav.navigate("wallet"));
        });
        this.session.on(AdFarmSession.OVERVIEW_CHANGED, this, this.refresh);
        this.refresh(this.session.overview);
    }

    destroy(destroyChild = true): void {
        this.session.off(AdFarmSession.OVERVIEW_CHANGED, this, this.refresh);
        super.destroy(destroyChild);
    }

    private refresh(overview: MobileOverview | null): void {
        const account = overview ? this.session.revenue.accountFor(overview, this.session.role) : null;
        this.valueLabel.text = Number(account?.totalBalance || 0).toFixed(2);
        this.valueLabel.color = Theme.cream;
    }
}
